/**
 * Handedness as it is shown, everywhere (RE-35, 27 October: full forms, never
 * R, L or S on their own): Bats RHB, LHB, SWH; Throws RHT, LHT. The stored
 * codes stay L / R / S. Segmented buttons that choose a hand keep their words
 * (Left / Right / Switch) - they are choices, not shown values.
 */
export const HAND_WORDS = {
  bats: { R: 'RHB', L: 'LHB', S: 'SWH' } as Record<string, string>,
  throws: { R: 'RHT', L: 'LHT' } as Record<string, string>,
  /** "RHB", "LHT"…, or null for nothing saved. An unknown code is shown as it is. */
  of(kind: 'bats' | 'throws', code: string | null | undefined): string | null {
    if (!code) return null;
    return HAND_WORDS[kind][code] ?? code;
  },
};
